




















































  import Vue from 'vue'
  import FileExplorer from '@/components/FileExplorer'
  import ManageCastFolders from '@/components/ManageCastFolders'
  import SubscribeTeamAssets from '@/mixins/SubscribeTeamAssets'
  import Modal from '@/components/Modal'
  import './AssetManager.scss'
  import {
    Asset,
    AssetFolderQuery,
    AssetGroup,
    AssetGroupErrors,
    AssetGroupType,
    AssetType,
    NewAssetRequest,
    TweetAsset,
    InstagramAsset,
    TweetPollAsset,
    VideoAsset
  } from '@/types/assets'
import { KeyDict } from '@/types'
import { Feature } from '@/featureFlags/featureFlags'
import { pickBy } from 'lodash'

  export default Vue.extend({
  name: 'AssetManager',
  mixins: [SubscribeTeamAssets],
  props: {
    activeTeam: {
      type: String
    },
    allAssets: {
      type: Object as () => KeyDict<Asset>
    },
    userId: {
      type: String
    },
    inCast: {
      type: Boolean,
      default: false
    },
    cast: {
      type: Object
    },
    streamsManager: {
      type: Object
    }
  },
  computed: {
    activeFolder (): AssetGroup | undefined {
      return this.$store.direct.getters.assets.activeFolder || undefined
    },
    isInitializing (): boolean {
      return this.$store.direct.getters.assets.initializing || false
    },
    isLoadingAssets (): boolean {
      return this.$store.direct.state.assets.folderAssetsLoading || false
    },
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    },
    selectedFolder (): string {
      // gets the last selected folder (even after switching tabs etc)
      return this.$store.direct.state.assets.selectedFolder
    },
    folderList (): KeyDict<AssetGroup> {
      if (!this.inCast) {
        return this.$store.direct.state.assets.folderList
      } else {
        return this.$store.direct.getters.events.castAssetGroups
      }
    },
    filteredFolders (): KeyDict<AssetGroup> {
      return pickBy(this.folderList, folder => !folder.parent_id)
    },
  },
  watch: {
    filteredFolders (_newVal) {
      if (!this.selectedFolder) {
        this.openFolder(AssetGroupType.RootFolder)
      }
    },
    activeTeam (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      this.$store.direct.dispatch.assets.clearTeamAssetGroups()
    }
  },
  data: () => ({
    showModal: false,
    showFolderModal: false,
    selectedMember: {},
    selectedFolders: [] as string[],
    folderAssets: [] as Asset[],
    folderDoc: {},
    folderQuery: null as null | AssetFolderQuery,
    loadingAsset: false,
    foldertype: '',
    folderHasChanged: false,
    minStars: 0,
  }),
  mounted () {
    console.log('assetManager mounted', this.selectedFolder)
    this.reloadAssets()
  },
  beforeDestroy () {
    // TODO move to mixins
    if (this.folderQuery !== null) {
      this.$store.direct.dispatch.assets.unsubscribeAssetFolderAssets(this.folderQuery)
      this.$store.direct.dispatch.assets.unsubscribeAssetFolderSubfolders(this.folderQuery)
    }
  },
  methods: {
    filterStars (stars) {
      this.minStars = stars
      this.openFolder(this.selectedFolder)
    },
    fileUploaded (file) {
      let state = 'done'
      if (file.type === 'video') {
        state = 'transcoding'
      }
      this.$store.direct.dispatch.assets.createAsset({
        team_id: this.activeTeam,
        user_id: this.userId,
        asset_group: this.selectedFolder,
        state,
        error: [],
        progress: 0,
        original_url: file.url,
        ...file
      })
    },
    addwidget (widget) {
      const name = widget.name
      this.$store
        .dispatch('assets/createAsset', {
          team_id: this.activeTeam,
          user_id: this.userId,
          asset_group: this.selectedFolder,
          ...widget
        })
        .then((widget: any) => {
          console.log('widget created ', widget)
          this.$message({
            type: 'success',
            message: `Widget ${name} has been created`
          })
        })
        .catch(error => {
          console.error('Add widget error', error)
        })
    },
    createFolder (folderName) {
      const data: NewAssetRequest = {
        name: folderName,
        team_id: this.activeTeam,
        parent_id: (this.activeFolder) ? this.activeFolder.id : '',
        type: AssetGroupType.Folder
      }
      if (this.inCast) {
        data.cast_id = this.cast.id
      }
      this.$store.dispatch('assets/createAssetFolder', data).then(() => {
        this.$message({
          type: 'success',
          message: `${this.folderTypeText(folderName)} ${folderName} has been created`
        })
      }).catch(error => {
        console.error('create Folder error', error)
      })
    },
    createHandle (folder) {
      const data: NewAssetRequest = {
        name: folder,
        team_id: this.activeTeam,
        parent_id: (this.activeFolder) ? this.activeFolder.id : '',
        type: AssetGroupType.TwitterHandle
      }
      if (this.inCast) {
        data.cast_id = this.cast.id
      }
      this.$store.dispatch('assets/createAssetFolder', data).then(() => {
        this.$message({
          type: 'success',
          message: `Handle ${folder} has been created`
        })
      }).catch(error => {
        console.error('createHandler error ' + folder, error)
      })
    },
    createHashtag (folder) {
      const data: NewAssetRequest = {
        name: folder,
        team_id: this.activeTeam,
        parent_id: (this.activeFolder) ? this.activeFolder.id : '',
        type: AssetGroupType.TwitterHashtag
      }
      if (this.inCast) {
        data.cast_id = this.cast.id
      }
      this.$store.dispatch('assets/createAssetFolder', data).then(() => {
        this.$message({
          type: 'success',
          message: `Hashtag ${folder} has been created`
        })
      }).catch(error => {
        console.error('createHashtag error', error)
      })
    },
    createInstagramHashtag (folder: string) {
      const data: NewAssetRequest = {
        name: folder,
        team_id: this.activeTeam,
        parent_id: (this.activeFolder) ? this.activeFolder.id : '',
        type: AssetGroupType.InstagramHashtag
      }
      if (this.inCast) {
        data.cast_id = this.cast.id
      }
      this.$store.dispatch('assets/createAssetFolder', data).then(() => {
        this.$message({
          type: 'success',
          message: `Instagram hashtag ${folder} has been created`
        })
      }).catch(error => {
        console.error('Instagram createHashtag error', error)
      })
    },
    createPoll (url) {
      const tweetPollAsset: TweetPollAsset = {
        ...new Asset(),
        name: 'Twitter poll',
        url: url,
        team_id: this.activeTeam,
        asset_group: (this.activeFolder) ? this.activeFolder.id : '',
        type: AssetType.TweetPoll,
      }

      this.$store.direct.dispatch.assets.createTwitterPoll(tweetPollAsset)
    },
    createLiveChat (input: {name: string, url: string, type: AssetGroupType}) {
      const data: NewAssetRequest = {
        name: input.name,
        remote_url: input.url,
        team_id: this.activeTeam,
        parent_id: (this.activeFolder) ? this.activeFolder.id : '',
        type: input.type // e.g. AssetGroupType.YouTubeChat
      }
      if (this.inCast) {
        data.cast_id = this.cast.id
      }
      this.$store.dispatch('assets/createAssetFolder', data).then(() => {
        this.$message({
          type: 'success',
          message: `'${input.name}' has been created`
        })
      }).catch(error => {
        console.error('createLiveChat error', error)
      })
    },
    createTweet (url: string) {
      const urlParts = url.split('/')
      const tweetId = urlParts[urlParts.length - 1] || ''
      const tweetAsset: TweetAsset = {
        ...new Asset(),
        name: 'Tweet',
        url: url,
        tweet_id: tweetId,
        team_id: this.activeTeam,
        asset_group: (this.activeFolder) ? this.activeFolder.id : '',
        type: AssetType.Tweet,
        parsed: false
      }

      this.$store.direct.dispatch.assets.createTweetAsset(tweetAsset)
    },
    createInstagramPost (url: string) {
      const post: InstagramAsset = {
        ...new Asset(),
        name: 'Instagram Post',
        url: url,
        data: '',
        team_id: this.activeTeam,
        asset_group: (this.activeFolder) ? this.activeFolder.id : '',
        type: AssetType.Instagram
      }
      this.$store.direct.dispatch.assets.createInstagramAsset(post)
    },
    unsubscribeFolder (force: boolean): boolean {
      if (this.folderQuery === null) {
        return true
      }
      if (!force && this.folderQuery.assetGroupId === this.selectedFolder && this.minStars === this.folderQuery.minStars) {
        return false
      }

      const isRootFolder = !this.folderQuery.assetGroupId
      if (isRootFolder === false) {
        this.$store.direct.dispatch.assets.unsubscribeAssetFolderAssets(this.folderQuery)
      }
      this.$store.direct.dispatch.assets.unsubscribeAssetFolderSubfolders(this.folderQuery)
      this.folderQuery = null
      return true
    },
    openFolder (folder: AssetGroup | string) {
      console.warn('openFolder ', folder)

      const isAssetGroupObject = !!(folder as AssetGroup).id
      const folderId = (isAssetGroupObject) ? (folder as AssetGroup).id : folder as string
      this.$store.direct.dispatch.assets.selectFolder(folderId)
      this.$store.direct.dispatch.assets.addFolderToSubscribedTeamAssetGroups(folderId)
      const shouldSubscribe = !!this.folderQuery && this.folderQuery.teamId !== this.activeTeam
      if (this.unsubscribeFolder(shouldSubscribe)) {
        if (folderId !== AssetGroupType.LiveStream) {
          this.folderQuery = {
            assetGroupId: folderId,
            minStars: this.minStars,
            teamId: this.activeTeam
          }
          this.$store.direct.dispatch.assets.subscribeAssetFolderAssets(this.folderQuery)
          this.$store.direct.dispatch.assets.subscribeAssetFolderSubfolders(this.folderQuery)
        }
      }
    },
    reloadAssets () {
      // e.g. when switching between current team assets need to be reloaded
      // console.log('reloadAssets --- (Clears previous assetGroups) openFolder', this.selectedFolder)
      this.openFolder(this.selectedFolder)
    },
    updateSingleAsset (data: Asset) {
      if (this.folderAssets.filter(asset => asset.id === data.id).length === 0) {
        let inserted = false
        const dataTimestamp = data.timestamp || 0
        for (let index = 0; index < this.folderAssets.length && !inserted; ++index) {
          const timestamp = this.folderAssets[index].timestamp
          if (timestamp && timestamp < dataTimestamp) {
            this.folderAssets.splice(index, 0, data)
            inserted = true
          }
        }
        if (!inserted) {
          this.folderAssets.push(data)
        }
      } else {
        for (let index = 0; index < this.folderAssets.length; ++index) {
          if (this.folderAssets[index].id === data.id) {
            this.folderAssets[index].stars = data.stars
            this.folderAssets[index].type = data.type
            if (this.folderAssets[index].type === AssetType.Video) {
              const asset = this.folderAssets[index] as VideoAsset
              const dataAsset = data as VideoAsset
              if (dataAsset.thumbnail !== undefined) {
                asset.thumbnail = dataAsset.thumbnail
              }
              if (dataAsset.state !== undefined) {
                asset.state = dataAsset.state
              }
              if (dataAsset.progress !== undefined) {
                asset.progress = dataAsset.progress
              }
              if (dataAsset.errors !== undefined) {
                asset.errors = dataAsset.errors
              }
            }
            if (this.folderAssets[index].type === AssetType.TweetPoll) {
              Object.keys(data).forEach(key => {
                this.folderAssets[index][key] = data[key]
              })
            }
          }
        }
      }
    },
    updateAsset (asset) {
      this.$store.dispatch('assets/updateAsset', asset ).then(() => {
        const assetName = (asset.type === 'igpost') ? 'Instagram post' : asset.name
        this.$message({
          type: 'success',
          message: `${assetName} has been updated`
        })
      }).catch(error => {
        console.error('updateAsset error', error)
      })
    },
    folderTypeText (folder) {
      if (folder && folder.type && folder.type.length > 1) {
        return folder.type.charAt(0).toUpperCase() + folder.type.slice(1)
      } else {
        return 'Folder'
      }
    },
    deleteFolder (folder) {
      console.log('delete folder', folder)

      this.$store.direct.dispatch.assets.deleteAssetFolder({ folder: folder, deepDelete: true }).then(() => {
        console.log('delete folder SUCCESS')
        this.$message({
          type: 'success',
          message: `${this.folderTypeText(folder)} ${folder.name} was deleted`
        })
      }).catch((error: Error) => {
        console.log('delete folder error', error)

        if (error.message && error.message === AssetGroupErrors.FolderNotEmpty) {
          this.$message({
            type: 'error',
            message: 'This folder can not be deleted while it is not empty.'
          })
          return
        }

        // show actual error from server
        this.$message({
          type: 'error',
          message: '' + error
        })
        console.error('delete folder error', error)
      })
    },
    formatFolders (folders) {
      this.selectedFolders = folders
      if (!this.selectedFolders.includes(this.selectedFolder)) {
        this.$store.direct.dispatch.assets.selectFolder(AssetGroupType.RootFolder)
      }
    },
    async addFoldersToCast () {
      const assetGroups : KeyDict<boolean> = {}
      for (let i = 0; i < this.selectedFolders.length; i++) {
        assetGroups[this.selectedFolders[i]] = true
      }
      try{
        await this.$store.direct.dispatch.events.updateCastAssetGroups(assetGroups)
      } catch( error ){
        console.warn('problem with addFoldersToCast:', error)
      }
      this.showFolderModal = false
    },
    closeModal () {
      this.showModal = false
    }
  },
  components: {
    FileExplorer,
    Modal,
    ManageCastFolders
  }
})
